import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { DealPromptDirectTag } from './DealPromptDirectTag.tsx';

type NameCellProps = {
  name: string;
  isDirect?: string[] | null;
};

export const NameCell = ({ name, isDirect }: NameCellProps) => {
  const shouldShowDirectTag = isDirect?.includes('true');

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignItems: 'center',
      }}
    >
      <Typography variant="body1Bold" data-test="row-title">
        {name}
      </Typography>
      {shouldShowDirectTag && <DealPromptDirectTag />}
    </Stack>
  );
};
